import React, { useEffect, useState } from "react";

import {
  Container,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  Box,
} from "@mui/material";

const API_URL = process.env.REACT_APP_API_URL;

export default function Ladder() {
  const [ladder, setLadder] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch(`${API_URL}/ladder`)
      .then((res) => {
        if (!res.ok) {
          throw new Error("Network response not ok");
        }

        return res.json();
      })
      .then(setLadder)
      .catch((err) => setError(err.message));
  }, []);

  if (error) {
    return (
      <Container sx={{ py: 4 }}>
        <Typography sx={{ color: "#FF5252" }}>
          Error loading ladder: {error}
        </Typography>
      </Container>
    );
  }

  return (
    <Container sx={{ py: 2 }}>
      {/* Header */}
      <Box sx={{ mb: 3 }}>
        <Typography
          variant="h4"
          sx={{
            color: "#F5F7FA",
            fontWeight: 800,
            letterSpacing: 1,
            mb: 1,
          }}
        >
          NRL LADDER
        </Typography>

        <Typography
          sx={{
            color: "#A7B3C2",
          }}
        >
          2026 Premiership Standings
        </Typography>
      </Box>

      {/* Table Card */}
      <Paper
        sx={{
          overflow: "hidden",
          borderRadius: 5,
          background: "linear-gradient(145deg, #0B2A57, #123C73)",
          border: "1px solid rgba(255,255,255,0.08)",
          boxShadow: "0 10px 30px rgba(0,0,0,0.35)",
        }}
      >
        <Box sx={{ overflowX: "auto" }}>
          <Table sx={{ minWidth: 950 }}>
            {/* Header */}
            <TableHead>
              <TableRow
                sx={{
                  backgroundColor: "rgba(255,255,255,0.04)",
                }}
              >
                {[
                  "Pos",
                  "Team",
                  "Played",
                  "Wins",
                  "Losses",
                  "Draws",
                  "PF",
                  "PA"
                ].map((header) => (
                  <TableCell
                    key={header}
                    sx={{
                      color: "#A7B3C2",
                      fontWeight: 700,
                      borderBottom:
                        "1px solid rgba(255,255,255,0.08)",
                      fontSize: "0.95rem",
                    }}
                  >
                    {header}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            {/* Body */}
            <TableBody>
              {ladder.map((team, index) => {
                const isWarriors =
                  team.team === "WAR" ||
                  team.team === "Warriors";

                return (
                  <TableRow
                    key={team.team}
                    sx={{
                      background: isWarriors
                        ? "linear-gradient(90deg, rgba(0,166,81,0.28), rgba(0,166,81,0.12))"
                        : "transparent",

                      transition: "0.2s ease",

                      "&:hover": {
                        backgroundColor:
                          "rgba(255,255,255,0.04)",
                      },

                      "& td": {
                        borderBottom:
                          "1px solid rgba(255,255,255,0.05)",
                      },
                    }}
                  >
                    {/* Position */}
                    <TableCell
                      sx={{
                        color: isWarriors
                          ? "#00E676"
                          : "#F5F7FA",

                        fontWeight: 700,
                      }}
                    >
                      {team.position}
                    </TableCell>

                    {/* Team */}
                    <TableCell
                      sx={{
                        color: "#F5F7FA",
                        fontWeight: isWarriors ? 800 : 600,
                        letterSpacing: 0.5,
                      }}
                    >
                      {team.team}
                    </TableCell>

                    {/* Played */}
                    <TableCell sx={{ color: "#F5F7FA" }}>
                      {team.played}
                    </TableCell>

                    {/* Wins */}
                    <TableCell
                      sx={{
                        color: "#00E676",
                        fontWeight: 700,
                      }}
                    >
                      {team.wins}
                    </TableCell>

                    {/* Losses */}
                    <TableCell
                      sx={{
                        color: "#FF5252",
                        fontWeight: 700,
                      }}
                    >
                      {team.losses}
                    </TableCell>

                    {/* Draws */}
                    <TableCell sx={{ color: "#A7B3C2" }}>
                      {team.draws}
                    </TableCell>

                    {/* Points For */}
                    <TableCell sx={{ color: "#F5F7FA" }}>
                      {team.points_for}
                    </TableCell>

                    {/* Points Against */}
                    <TableCell sx={{ color: "#F5F7FA" }}>
                      {team.points_against}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </Box>
      </Paper>
    </Container>
  );
}